import { render, staticRenderFns } from "./AppEditDialog.vue?vue&type=template&id=96749ba8&scoped=true"
import script from "./AppEditDialog.vue?vue&type=script&lang=js"
export * from "./AppEditDialog.vue?vue&type=script&lang=js"
import style0 from "./AppEditDialog.vue?vue&type=style&index=0&id=96749ba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96749ba8",
  null
  
)

export default component.exports